import { useEffect } from 'react';
import { useTimeout } from './useTimeout';

export const useDebounce = (callback: (...args: any[]) => any, delay: number, dependencies: any[]): any => {
    const { reset, clear } = useTimeout(callback, delay);

    useEffect(reset, [...dependencies, reset]);

    useEffect(clear, []);
};
